import http from '../core/http-common'
import { IContract } from '../types/ContractType'
import { ITransactionResponse } from '../types/MainType'

class ContractService {
  getPendingContractList() {
    return http.get<IContract[]>(`/ContractEmployee/GetPendingContractList`)
  }

  SaveContractEmployee(request: { contractId: number; isApprove: boolean }) {
    return http.post<ITransactionResponse>('/ContractEmployee/SaveContractEmployee', request)
  }
}

export default new ContractService()
